import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import {
  Radio,
  Form,
  Row,
  Col,
  Input,
  Button,
  DatePicker,
  Select,
} from "antd/lib";
import { EditOutlined } from "@ant-design/icons";
import { CustomerDetails } from "../../Redux/actions/NumBikeation";
import moment from "moment";
import { CalendarOutlined, CheckOutlined } from "@ant-design/icons";
import CarCustomerdisplay from "./CarCusDisplay";
import { Prop1side } from "../proposols/step1/prop1Side";
import { Proposal1 } from "../proposols/step1/proposal1";
import { Proposal2 } from "../proposols/step2/prop2body";
// import { Proposal3 } from "../proposols/step3/prop3body";
import { ProposalCarinfo } from "../RolloverCar/ProposalCarInfo";
// import { PreviousPolicyDetails } from "./PreviousPolicyDetail";
import { PreviousPolicyDetailCar } from "./PrevPolicydetailcar";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { set_info1 } from "../../Redux/action";

const CarCustomerInfo = () => {
  const carnum = useSelector((state) => state?.cardetail?.carnum);

  const CustDetail = useSelector((state) => state?.common?.customerDetail);
  const QuickQuotePost = useSelector(
    (state) => state?.cardetail?.quickQuotePost
  );
  const QuickQuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  // console.log("QuickQuotePost", QuickQuotePost);
  const [form] = Form.useForm();
  const Ref = useRef(null);
  const Ref2 = useRef(null);
  const Ref3 = useRef(null);
  const Ref4 = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [Age, setAge] = useState("");
  const [dob, setDob] = useState("");
  const [showCkyc, setShowCyc] = useState(false);
  const [showAadhaar, setShowAadhar] = useState(false);
  const [showStep1, setShowStep1] = useState(false);
  const [showStep2, setShowStep2] = useState(false);
  const [showStep3, setShowStep3] = useState(false);
  const [showStep4, setShowStep4] = useState(false);
  const [showStep5, setShowStep5] = useState(false);
  const [kycNumvalue, setkycNum] = useState("No");
  const [ckycDocId, setckycDocId] = useState(
    CustDetail?.ckycReferenceDocId ? CustDetail?.ckycReferenceDocId : "D07"
  );
  const [CkycType, setCkycType] = useState(
    CustDetail?.ckyc_type ? CustDetail?.ckyc_type : "PAN"
  );
  const [iciciKycSuccess, setIciciKycSuccess] = useState("");
  const [iciciKycError, setIciciKycError] = useState("");
  // const [docId, setDocId] = useState('');
  useEffect(() => {
    if (CkycType === "AADHAAR") {
      setShowAadhar(true);
    }
  }, [CkycType]);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  const onChange = (e) => {
    // console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ PAN_Number: e.target.value });
  };
  const calculateAge = (date) => {
    // console.log(date);

    const dateString = moment(date).format("YYYY-MM-DD");
    // console.log(dateString);

    setDob(dateString);
    const dobObject = new Date(date); // Convert the date string to a Date object
    // console.log(dobObject);
    const ageDifMs = Date.now() - dobObject.getTime(); // Get the difference in milliseconds
    // console.log(ageDifMs);

    const ageDate = new Date(ageDifMs); // Create a new date object using the difference
    // console.log(ageDate);

    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    // console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
    } else {
      setAge(ageInYears);
    }
    // console.log(Age);
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const customerEdit = () => {
    setShowStep1(false);
    setShowStep2(false);
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditOwner = () => {
    setShowStep2(false);
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditNominee = () => {
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditVehicle = () => {
    setShowStep4(false);
    setShowStep5(false);
  };
  const handleAadhaarNumberChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    const truncatedValue = inputValue.slice(0, 12);
    const formattedValue = truncatedValue.replace(/^[01]/, "");
    const finalValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    e.target.value = finalValue;
    form.setFieldsValue({ aadhaar_number: finalValue });
  };
  const handleGSTChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ gst_number: e.target.value });
  };
  // console.log(ckycDocId);
  const onFinish = (data) => {
    // console.log("data", data);
    data.DateOfBirth = moment(data?.DateOfBirth).format("YYYY-MM-DD");
    data.ckyc_type = CkycType;
    data.ckycReferenceDocId = ckycDocId;
    switch (ckycDocId) {
      case "D03":
        data.ckycReferenceNumber = data?.aadhaar_number;
        break;
      case "D07":
        data.ckycReferenceNumber = data?.PAN_Number;
        break;
      case "D02":
        data.ckycReferenceNumber = data?.ckyc_number;
        break;
      default:
    }
    setLoading(true);
    // console.log(data);
    // dispatch(CustomerDetails(data));
    dispatch(CustomerDetails(data));
    if (SelectedQQ?.provider !== "icici") {
      const timeoutId = setTimeout(() => {
        setLoading(false);
        setShowStep1(true);
        Ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return () => clearTimeout(timeoutId);
    }
    // setTimeout(() => {
    //   setLoading(false);
    //   setShowStep1(true);
    //   Ref.current?.scrollIntoView({ behavior: "smooth" });
    //   //history.push("/step1");
    // }, 500);
  };
  const handleReview = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      history.push("/carlogin");
    }, 1000);
  };
  const onChangeCkycType = (e) => {
    // console.log(e);
    setCkycType(e);
    if (e === "AADHAAR") {
      setShowAadhar(true);
      setckycDocId("D03");
    } else if (e === "PAN") {
      setShowAadhar(false);
      setckycDocId("D07");
    }
  };
  const OnckycChange = (e) => {
    setkycNum(e.target.value);
    // console.log("radio checked", e.target.value);
    if (e.target.value === "Yes") {
      setShowCyc(true);
      setShowAadhar(false);
      setckycDocId("D02");
    } else if (e.target.value === "No") {
      setShowCyc(false);
      setShowAadhar(true);
      switch (CkycType) {
        case "AADHAAR":
          setckycDocId("D03");
          break;
        case "PAN":
          setckycDocId("D07");
          break;
        default:
          setckycDocId("");
          break;
      }
    }
  };
  const handleKYCiCICI = (values) => {
    // console.log('handleKYCiCICI',values)
    setLoading(true);
    setShowStep1(false);
    let aadhaarNumber = values?.aadhaar_number;
    aadhaarNumber = aadhaarNumber?.replace(/\s/g, "");
    let post = {
      insurance_id: carnum?.car_insurance_id,
      pan_card_number: values?.PAN_Number,
      dob: moment(values?.DateOfBirth).format("DD-MM-YYYY"),
      type: kycNumvalue === "Yes" ? "CKYC" : CkycType,
      //
      ckyc_number: values?.ckyc_number,
      aadhaar_number: aadhaarNumber,
      full_name: values?.AadhaarName,
      gender: values?.gender === "male" ? "M" : "F",
    };
    // v2/car_insurances/{insurance}/insurers/{insurer}/kyc_status

    axiosInCar
      .post(
        `v2/car_insurances/${carnum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        // console.log(res?.data);
        const Kycdata = res?.data?.data;
        console.log(Kycdata);
        if (Kycdata.status === "success") {
          let KYC = Kycdata?.kyc_details;
          var data = {
            Owner: KYC?.first_name,
            Mobile: KYC?.mobile_number,
            Email: KYC?.email,
            Address: KYC?.permanent_address?.address_line_1,
            CkycNumber: KYC?.ckyc_number,
            City: KYC?.permanent_address?.city,
            il_kyc_ref_no: KYC?.il_kyc_ref_no,
            Pincode: KYC?.permanent_address?.pin_code,
          };
          dispatch(set_info1(data));
          setLoading(false);
          setIciciKycError("");
          setIciciKycSuccess("KYC Verified Successfully");
          setTimeout(() => {
            setShowStep1(true);
            Ref.current?.scrollIntoView({ behavior: "smooth" });
          }, 1000);
        } else {
          setLoading(false);
          setShowStep1(false);
          setIciciKycError(Kycdata?.message);
          setIciciKycSuccess("");
          // setTimeout(() => {
          //   setShowStep1(true);
          //   Ref.current?.scrollIntoView({ behavior: "smooth" });
          // }, 1000);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setShowStep1(false);
        setIciciKycSuccess("");
        setIciciKycError(err?.data?.message);
      });
  };
  return (
    <>
      <NavbarJourney />
      <div className="row py-3">
        <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12">
          <Prop1side />
        </div>
        <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
          <div className="container d-flex justify-content-center flex-column">
            <div>
              <div
                className="step1-header-skb custdetail"
                style={{ marginBottom: "0px" }}
                ref={Ref}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Know Your Customer
                </h4>
                {showStep1 ? <EditOutlined onClick={customerEdit} /> : null}
              </div>
              <p style={{ margin: "10px 0px" }}>
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                To Complete the purchase, we need the following customer
                details.
              </p>
              {showStep1 ? (
                <CarCustomerdisplay />
              ) : (
                <div className=" d-flex bg-white customer-card">
                  <Form
                    form={form}
                    style={{ width: "100%" }}
                    requiredMark={true}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                  >
                    <Row gutter={24}>
                      <Col span={8}>
                        <Form.Item
                          {...formItemLayout}
                          label="Date of Birth(as per PAN card)"
                          name="DateOfBirth"
                          rules={[
                            {
                              required: true,
                              message: "Please select DOB",
                            },
                          ]}
                          initialValue={
                            CustDetail.DateOfBirth
                              ? moment(CustDetail.DateOfBirth)
                              : null
                          }
                        >
                          <DatePicker
                            suffixIcon={
                              Age ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "4px",
                                      color: "#0000ff94",
                                    }}
                                  >
                                    {Age} Years
                                  </span>
                                  <CalendarOutlined />
                                </div>
                              ) : (
                                <CalendarOutlined />
                              )
                            }
                            style={{ width: "100%", padding: "8px 10px" }}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD"
                            onChange={calculateAge}
                            defaultPickerValue={getDefaultPickerValue()}
                            placeholder="YYYY-MM-DD"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...formItemLayout}
                          label="Gender"
                          name="gender"
                          rules={[
                            {
                              required: true,
                              message: "Please select gender",
                            },
                          ]}
                          initialValue={CustDetail.gender}
                        >
                          <Radio.Group
                            style={{ width: "100%", gap: "10px" }}
                            className="d-flex radio-grp-custom"
                            onChange={onChange}
                          >
                            <Radio.Button
                              value="male"
                              className="radio-btn-cut-sec"
                            >
                              Male
                            </Radio.Button>
                            <Radio.Button
                              value="female"
                              className="radio-btn-cut-sec"
                            >
                              Female
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...formItemLayout}
                          name="is_ckyc"
                          label="Do you have CKYC Number?"
                          rules={[
                            { required: true, message: "Enter CKYC Number" },
                          ]}
                          initialValue={kycNumvalue}
                        >
                          <Radio.Group
                            onChange={OnckycChange}
                            style={{ width: "100%", gap: "10px" }}
                            className="d-flex radio-grp-custom"
                          >
                            <Radio.Button
                              value="Yes"
                              className="radio-btn-cut-sec"
                            >
                              Yes
                            </Radio.Button>
                            <Radio.Button
                              value="No"
                              className="radio-btn-cut-sec"
                            >
                              No
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {showCkyc === true ? (
                        <Col span={8}>
                          <Form.Item
                            {...formItemLayout}
                            initialValue={CustDetail?.ckyc_number}
                            name="ckyc_number"
                            label="CKYC Number"
                            rules={[
                              {
                                pattern: /^[0-9]+$/,
                                message: "Must be only digits",
                              },
                              { required: true, message: "Enter CKYC Number" },
                            ]}
                          >
                            <Input
                              maxLength={14}
                              placeholder="Enter CKYC Number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col span={8}>
                          <Form.Item
                            {...formItemLayout}
                            initialValue={CkycType}
                            name="ckyc_type"
                            label="CKYC Type"
                            rules={[
                              { required: true, message: "select CKYC type" },
                            ]}
                          >
                            <Select
                              // defaultValue={CkycType}
                              placeholder="Select Ckyc type"
                              onChange={onChangeCkycType}
                              options={[
                                {
                                  value: "PAN",
                                  label: "PAN NUMBER",
                                },
                                {
                                  value: "AADHAAR",
                                  label: "AADHAAR NUMBER",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {showAadhaar === true && CkycType === "AADHAAR" ? (
                        <Col span={8}>
                          <Form.Item
                            {...formItemLayout}
                            initialValue={CustDetail?.aadhaar_number}
                            name="aadhaar_number"
                            label="Aadhaar Number"
                            rules={[
                              {
                                required: true,
                                message: "Enter Aadhaar Number",
                              },
                              {
                                pattern:
                                  /^(?!0|1)\d{4}(?!0|1)\s?\d{4}(?!0|1)\s?\d{4}$/,
                                message: "Invalid Aadhaar Number",
                              },
                            ]}
                          >
                            <Input
                              style={{ padding: "2px 10px" }}
                              onChange={handleAadhaarNumberChange}
                              placeholder="Enter Aadhaar Number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      ) : null}
                      <Col span={8}>
                        <Form.Item
                          {...formItemLayout}
                          initialValue={CustDetail?.PAN_Number}
                          name="PAN_Number"
                          label="PAN Number"
                          rules={[
                            {
                              pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i,
                              message: "Invalid PAN Number",
                            },
                            { required: true, message: "Enter PAN Number" },
                          ]}
                        >
                          <Input
                            style={{ padding: "2px 10px" }}
                            onChange={handleInputChange}
                            placeholder="Enter PAN Number"
                          ></Input>
                        </Form.Item>
                      </Col>
                      {QuickQuotePost?.policyHolderType === "COMPANY" ? (
                        <Col span={8}>
                          <Form.Item
                            {...formItemLayout}
                            initialValue={CustDetail?.gst_number}
                            name="gst_number"
                            label="GSTIN"
                            rules={[
                              { required: true, message: "Enter GST Number" },
                              {
                                pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{4}$/,
                                message: "Invalid GST Number",
                              },
                            ]}
                          >
                            <Input
                              style={{ padding: "2px 10px" }}
                              onChange={handleGSTChange}
                              placeholder="e.g 01ABCDE1234ABCD"
                            ></Input>
                          </Form.Item>
                        </Col>
                      ) : null}
                    </Row>
                    <Form.Item
                      className="mb-0 text-center"
                      {...buttonItemLayout}
                    >
                      {iciciKycSuccess ? (
                        <p className="successKyc">
                          <span style={{ marginRight: "4px" }}>
                            <CheckOutlined />
                          </span>
                          {iciciKycSuccess}
                        </p>
                      ) : null}
                      {iciciKycError ? (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          {iciciKycError}
                        </p>
                      ) : null}
                      {SelectedQQ?.provider === "icici" ? (
                        showStep1 ? null : (
                          <Button
                            type="primary"
                            style={{ background: "#293890", border: "#293890" }}
                            htmlType="submit"
                            loading={loading}
                            onClick={() =>
                              handleKYCiCICI(form.getFieldsValue())
                            }
                          >
                            Verify KYC
                          </Button>
                        )
                      ) : showStep1 ? null : (
                        <Button
                          type="primary"
                          style={{ background: "#293890", border: "#293890" }}
                          htmlType="submit"
                          loading={loading}
                        >
                          Proceed To Owner Information
                        </Button>
                      )}
                    </Form.Item>
                  </Form>
                </div>
              )}
            </div>
            <div className="step2" style={{ marginTop: "30px" }}>
              <div
                className={showStep1 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Owner Information
                </h4>
                {showStep2 ? (
                  <EditOutlined onClick={customerEditOwner} />
                ) : null}
              </div>
              {showStep1 ? (
                <Proposal1
                  setShowStep2={setShowStep2}
                  showStep2={showStep2}
                  Ref2={Ref2}
                />
              ) : null}
            </div>
            <div className="step2">
              <div
                className={showStep2 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref2}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Nominee Details
                </h4>
                {showStep3 ? (
                  <EditOutlined onClick={customerEditNominee} />
                ) : null}
              </div>
              {showStep2 ? (
                <Proposal2
                  setShowStep3={setShowStep3}
                  showStep3={showStep3}
                  Ref3={Ref3}
                />
              ) : null}
            </div>
            <div className="step2">
              <div
                className={showStep3 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref3}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Vehicle Information
                </h4>
                {showStep5 ? (
                  <EditOutlined onClick={customerEditVehicle} />
                ) : null}
              </div>
              {showStep3 ? (
                <ProposalCarinfo
                  setShowStep4={setShowStep4}
                  showStep4={showStep4}
                  setShowStep5={setShowStep5}
                  showStep5={showStep5}
                  Ref4={Ref4}
                />
              ) : null}
            </div>
            {QuickQuoteInput?.insuranceProductCode === "Not_Secure" ? null : (
              <div className="step2">
                <div
                  className={showStep5 ? `step1-header-skb custdetail` : null}
                  style={{ marginBottom: "0px" }}
                  ref={Ref4}
                >
                  <h4 className="mb-0" style={{ fontSize: "19px" }}>
                    Previous Policy Information
                  </h4>
                </div>
                {showStep5 ? (
                  <PreviousPolicyDetailCar
                    setShowStep4={setShowStep4}
                    showStep4={showStep4}
                  />
                ) : null}
              </div>
            )}
            <>
              {showStep4 ? (
                <div className="btnreviewsub">
                  <Button
                    loading={loading}
                    onClick={handleReview}
                    type="primary"
                    htmlType="submit"
                  >
                    Review & Submit
                  </Button>
                </div>
              ) : null}
            </>
          </div>
        </div>
      </div>
    </>
  );
};
export default CarCustomerInfo;
